export default __webpack_public_path__ + "static/designSystem-ab782cedc00a79a11c24a15c071f8a44.png";